import { IItem } from '../../components/Tabs';
import {
  EOfferStatus,
  ERoomsCount,
} from '../../repositories/valuation-offer-history/v1/get-house-offer-history-desktop';
import { EStatus } from '../../repositories/valuation-offer-history/entities/offer_history/OfferHistoryStatusCountItemSchema';
import { EPriceDiff } from '../../repositories/valuation-offer-history/entities/offer_history/HouseOfferHistoryDesktopSchema';

export interface IOffer {
  id: number;
  card: IOfferCard;
  offerStart: IOfferPrice;
  offerActual: IOfferActual;
  offerValuation: IOfferValuation;
}

export interface IOfferCard {
  img?: string | null;
  link?: string | null;
  title: string;
  expoTime: string;
}

export interface IOfferPrice {
  date?: string | null;
  price: string;
  priceSqm?: string | null;
}

export interface IOfferActual extends IOfferPrice {
  priceDiff: EPriceDiff;
}

export interface IOfferValuation {
  price: string;
  priceSqm?: string | null;
}

export const STATUS_ALL = 'all';
export type TStatusFiltersID = EOfferStatus | EStatus | typeof STATUS_ALL;
export type TRoomsFiltersID = ERoomsCount | typeof STATUS_ALL;

export type TStatusFilterItem = IItem<TStatusFiltersID>;
export type TRoomsFilterItem = IItem<TRoomsFiltersID>;
export type TStatusFilters = TStatusFilterItem[];
export type TRoomsFilters = TRoomsFilterItem[];

export type TStatusFiltersActiveIDs = [TStatusFiltersID];
export type TRoomsFiltersActiveIDs = [TRoomsFiltersID];

export interface IOfferHistoryData {
  offers: IOffer[];
  roomsFilters?: TRoomsFilters | null;
  statusFilters?: TStatusFilters | null;
  totalCount: number;
  blockTitle: string;
}

export interface IOfferHistory {
  data: IOfferHistoryData | null;
  isFetching: boolean;
  isError: boolean;
  roomsFiltersActiveIDs?: TRoomsFiltersActiveIDs | null;
  statusFiltersActiveIDs?: TStatusFiltersActiveIDs | null;
  page: number;
  resultsOnPage: number;
}

export { EOfferStatus, ERoomsCount };
